"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.labelWeekNumber = void 0;
/**
 * The default ARIA label for the WeekNumber element.
 */
var labelWeekNumber = function (n) {
    return "Week n. " + n;
};
exports.labelWeekNumber = labelWeekNumber;
//# sourceMappingURL=labelWeekNumber.js.map